import type { GetAccountResponse } from '@pushly/models/lib/structs'
import { createContext, useContext, useReducer } from 'react'
import { AccountMfaConfig } from '@pushly/models/lib/structs/accounts'

type OrgContext = {
    org: GetAccountResponse
}

export const OrgContext = createContext<OrgContext>(null!)

type OrgContextReducerAction =
    | {
          type: 'patch_mfa'
          value: AccountMfaConfig
      }
    | {
          type: 'patch_session_timeouts'
          value: { idle_timeout_minutes: number; absolute_timeout_minutes: number }
      }

const handleOrgContextReducerRequest = (ctx: OrgContext, action: OrgContextReducerAction) => {
    switch (action.type) {
        case 'patch_mfa':
            return { org: ctx.org.clone({ mfa_config: action.value }) }
        case 'patch_session_timeouts':
            return {
                org: ctx.org.clone({
                    idle_timeout_minutes: action.value.idle_timeout_minutes,
                    absolute_timeout_minutes: action.value.absolute_timeout_minutes,
                }),
            }
    }
}

export const useOrgContextWithReducer = () => {
    const { org } = useContext(OrgContext)
    return useReducer(handleOrgContextReducerRequest, { org })
}
